import { FULL_ARCH_PER_ARCH_FROM } from './fullArchPricing.js';

// Review facts are owned by the patient-reviews catalog. Do not duplicate them here.
import { GOOGLE_RATING, GOOGLE_REVIEW_COUNT, VERIFIED_ON, GOOGLE_REVIEW_URL, RATING_DISPLAY, RATING_STARS, REVIEW_COUNT_DISPLAY, RATING_SUMMARY } from './reviews';
export { GOOGLE_RATING, GOOGLE_REVIEW_COUNT, VERIFIED_ON, GOOGLE_REVIEW_URL, RATING_DISPLAY, RATING_STARS, REVIEW_COUNT_DISPLAY, RATING_SUMMARY };

/**
 * Verifiable practice facts. Every entry here must be checkable against a
 * primary source — a credentialing body, the office, or the patient record.
 * Unverifiable superlatives ("#1 in Pasco County", "best implant dentist")
 * do not belong in this file or anywhere else on the site.
 */
export const PRACTICE_FACTS = {
  yearsImplantFocused: '20+',
  credentials: 'MAGD · DABOI/ID · DICOI · FAAID',
  credentialsLong: 'MAGD, DABOI/ID, DICOI, FAAID',
  doctor: 'Dr. Xhoana Gjelaj, DMD',
  inHouseLab: 'Trinity Dental Studio — CAD/CAM design & SprintRay 3D printing',
  imaging: '3D CBCT & computer-guided implant surgery',
  financing: 'CareCredit, Cherry and Proceed',
  phone: '(727) 228-6846',
  phoneHref: 'tel:+17272286846',
  address: '11105 Trinity Blvd, Trinity, FL 34655',
  hours: 'Monday – Thursday, 9:00am – 5:00pm',
};

export default {
  GOOGLE_RATING,
  GOOGLE_REVIEW_COUNT,
  VERIFIED_ON,
  GOOGLE_REVIEW_URL,
  RATING_DISPLAY,
  RATING_STARS,
  REVIEW_COUNT_DISPLAY,
  RATING_SUMMARY,
  PRACTICE_FACTS,
};

/** Full-arch minimum fees come from the v8.2 fee schedule. Other fees require individual confirmation. */
export const TREATMENT_PRICING = {
  singleImplantApproximate: 5500,
  allOn4PerArchFrom: FULL_ARCH_PER_ARCH_FROM,
  signatureConsult: 300,
  signatureCreditDays: 30,
  removableSnapInDenturesOffered: false,
};